<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group :submissionId="submissionId" />
      <hr class="mt-0" />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="question" />
        </template>
      </div>
      <div v-if="currentSubmission">
        <template v-for="(item, index) in currentSubmission.bore_holes">
          <project-irrigation-bore-hole
            :key="index"
            :submissionId="submissionId"
            :boreHoleId="item.bore_hole_id"
            :textureOptions="texture_options"
            :horizonOptions="horizon_options"
          />
        </template>
      </div>
      <b-row>
        <b-col>
          <b-button block variant="success" @click="addBoreHole">
            <i class="fa fa-plus" /> Add Bore Hole
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectIrrigationBoreHole from "./ProjectIrrigationBoreHole";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectIrrigationSubmissionForm",
  components: {
    ProjectFieldFormGroup,
    ProjectIrrigationBoreHole,
  },
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
    managedLists: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    bore_holes() {
      return this.currentSubmission.bore_holes;
    },
    texture_options() {
      return this.createOptionList(
        this.managedLists.find(
          (item) =>
            item.sub_type === "irrigation_suitability" &&
            item.list === "texture"
        ).attribute_lists,
        "field_texture"
      );
    },
    horizon_options() {
      return this.createOptionList(
        this.managedLists.find(
          (item) =>
            item.sub_type === "irrigation_suitability" &&
            item.list === "horizon"
        ).attribute_lists,
        "soil_horizon"
      );
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    addBoreHole() {
      const newBoreHole = this.generateBoreHole();
      this.bore_holes.push(newBoreHole);
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.bore_holes,
        name: "bore_holes",
      });
    },
    generateBoreHole() {
      return {
        identifier: `Bore Hole ${this.bore_holes.length + 1}`,
        bore_hole_id: this.$uuid.v4(),
        samples: [
          {
            identifier: "Sample 1",
            test_package_sample_id: this.$uuid.v4(),
            field_texture: null,
            soil_horizon: null,
            depth_start: 0,
            depth_end: 6,
          },
        ],
      };
    },
    createOptionList(list, field) {
      return {
        options: list.map((item) => ({ id: item.id, name: item.value })),
        field,
      };
    },
  },
};
</script>
